import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

// Evento que dispara la tarjeta de Configuración al guardar, para que el aviso se actualice al instante.
export const EVENTO_MANTENIMIENTO = 'mantenimiento-cambiado';

// Estado del bloqueo temporal del schema (GET /api/mantenimiento). Se refresca cada minuto.
export default function useMantenimiento(intervaloMs = 60000) {
  const [estado, setEstado] = useState(null);

  const recargar = useCallback(async () => {
    try {
      const res = await axios.get('/api/mantenimiento');
      setEstado(res.data?.data || null);
    } catch {
      // Sin sesión o sin red: no hay aviso. Un fallo aquí no debe molestar al usuario.
    }
  }, []);

  useEffect(() => {
    recargar();
    const id = setInterval(recargar, intervaloMs);
    window.addEventListener(EVENTO_MANTENIMIENTO, recargar);
    return () => {
      clearInterval(id);
      window.removeEventListener(EVENTO_MANTENIMIENTO, recargar);
    };
  }, [recargar, intervaloMs]);

  return { estado, recargar };
}
